// extracted by mini-css-extract-plugin
module.exports = {"moveWrapper":"LandingsTable_moveWrapper__3veuX"};